import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

// Single source of truth for "USA Time" across the whole app — US Eastern
// Time, the common default reference zone for a US-facing business — so
// every page/module shows the same clock and the same date regardless of
// the server's or the viewer's own local timezone.
export const USA_TIMEZONE = "America/New_York";

// A dayjs instance already converted to USA time. Pass nothing to get
// "right now" in USA time (for a live clock); pass any date/ISO
// string/timestamp to convert a stored date into USA time for display.
export const toUsaDayjs = (input) => (input == null ? dayjs() : dayjs(input)).tz(USA_TIMEZONE);

export const formatUsaDate = (input, fmt = "MMM DD, YYYY") =>
    input ? toUsaDayjs(input).format(fmt) : "—";

export const formatUsaDateTime = (input, fmt = "MMM DD, YYYY h:mm A") =>
    input ? toUsaDayjs(input).format(fmt) : "—";
